export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_grey.b64ba774.jpg";